import { Text } from "@chakra-ui/react"
import { t } from "i18next"
import { FC } from "react"
import { FaBook } from "react-icons/fa6"
import { GiFairyWand } from "react-icons/gi"
import { Icon } from "src/components/common/icons"
import useConfig, { Configs } from "src/hooks/useConfig"

type IconProps = {
  marginRight?: string
  boxSize?: string
}

export const InspirationsButtonIcon: FC<IconProps> = ({
  marginRight,
  boxSize
}) => {
  const { platformName } = useConfig()
  if (platformName === "LearnMachine") {
    return <Icon src={FaBook} marginRight={marginRight} boxSize={boxSize} />
  } else {
    return (
      <Icon src={GiFairyWand} marginRight={marginRight} boxSize={boxSize} />
    )
  }
}

export const inspirationsButtonText = (configs: Configs) => {
  const { platformName } = configs
  if (platformName === "LearnMachine") {
    return t("Topics")
  } else {
    return t("Inspirations")
  }
}
